// extracted by mini-css-extract-plugin
module.exports = {"container":"NotificationPopup_container__AfZVY","mainTextStyle":"NotificationPopup_mainTextStyle__29uLZ"};